import { User } from "oidc-client-ts";
import { config } from "./config";

/**
 * Get user from storage (oidc-client-ts.User.ts)
 * This method is useful if you need user data but aren't executing in the AuthProvider's context
 * [Link](https://github.com/authts/react-oidc-context#call-a-protected-api)
 * @returns User | null
 */
const getUser = () => {
  const oidcStorage = localStorage.getItem(`oidc.user:${config.oidcAuthority}:${config.oidcClientId}`);
  return !oidcStorage ? null : User.fromStorageString(oidcStorage);
}

export default getUser;